/* eslint-disable */
import React from 'react';
import './FTEStatusTable.css';

const FTEStatusTable = ({ data }) => {
  const downloadCSV = () => {
    if (!data || data.length === 0) return;
    const headers = ["Tower", "Work Area", "Business Approver", "Actual FTE Nos", "Actual Qtr", "Status"];
      const rows = data.map(row => [
      row.tower,
      row.workArea,
      row.businessApprover,
      row.actualFTE,
      row.actualQtr,
      row.status
    ]);
    const csvContent = [headers, ...rows]
      .map(e => e.map(field => `"${String(field).replace(/"/g, '""')}"`).join(","))
      .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "FTEStatusData.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="fte-table-wrapper">
      <div className="download-btn-wrapper">
        <button className="download-btn" onClick={downloadCSV}>Download CSV</button>
      </div>
      <table className="fte-table">
        <thead>
          <tr>
            <th>Tower</th>
            <th>Work Area</th>
            <th>Business Approver</th>
            <th>Actual FTE Nos</th>
            <th>Actual Qtr</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              <td>{row.tower}</td>
              <td>{row.workArea}</td>
              <td>{row.businessApprover}</td>
              <td>{row.actualFTE}</td>
              <td>{row.actualQtr}</td>
              {/* <td className={`status-cell ${row.status.toLowerCase().replace(' ', '-')}`}>
                {row.status}
              </td> */}
              {/* <td className={`status-cell ${row.status.toLowerCase().replace(' ', '-')}`}>
                {row.status}
              </td> */}
              <td className={`status-cell ${row.status ? row.status.toLowerCase().replace(' ', '-') : ''}`}>
                {row.status || 'N/A'}
              </td>
            </tr>
          ))}
          <tr className="total-row">
            <td colSpan={3}>Grand Total</td>
            {/* <td>{data.reduce((acc, item) => acc + item.actualFTE, 0)}</td> */}
            <td>
              {data
                .reduce((acc, item) => acc + (parseFloat(item.actualFTE) || 0), 0)
                .toFixed(2)}
            </td>
            <td colSpan={2}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FTEStatusTable;
